import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Crear el root de React
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderizar la aplicación
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Configuración para desarrollo
if (process.env.NODE_ENV === 'development') {
  // Log de información de desarrollo
  console.log('🚀 Polares Data Loader - Frontend iniciado en modo desarrollo');
  console.log('📡 API Base URL:', process.env.REACT_APP_API_URL || '/api');
  console.log('🌟 React Version:', React.version);
}
